'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormInput = function (_Component) {
    (0, _inherits3.default)(FormInput, _Component);

    function FormInput() {
        (0, _classCallCheck3.default)(this, FormInput);
        return (0, _possibleConstructorReturn3.default)(this, (FormInput.__proto__ || (0, _getPrototypeOf2.default)(FormInput)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                form = _props.form,
                id = _props.id,
                rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'form', 'id']);
            var fieldErrors = form.fieldErrors,
                fieldValid = form.fieldValid;


            return _react2.default.createElement(
                _Input2.default,
                (0, _extends3.default)({
                    errorMessage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: fieldErrors[id]
                    }),
                    id: id,
                    label: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'formLabels.' + id
                    }),
                    valid: fieldValid[id]
                }, rest),
                children
            );
        }
    }]);
    return FormInput;
}(_react.Component);

exports.default = FormInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Input/FormInput.js
// module id = MFq5
// module chunks = 57